// useConfirmationModal.js
import { reactive, unref } from 'vue';
import { wTrans } from 'laravel-vue-i18n';

const btnVariantMap = {
  danger: 'danger',
  success: 'secondary',
  primary: 'secondary',
  warning: 'secondary',
};

const defaultState = {
  visible: false,
  title: '',
  description: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  variant: 'primary',
  btnVariant: 'secondary',
  cancelColor: 'gray',
  loading: false,
  resolve: null,
  reject: null,
  loadingFn: null,
};

const state = reactive({ ...defaultState });

export function useConfirmationModal() {
  return (options = {}) => {
    return new Promise((resolve, reject) => {
      // Reset state to defaults first
      resetConfirmationState();

      // Then set new values, converting computed refs to plain strings
      const variant = options.variant || 'primary';
      state.visible = true;
      state.title = unref(options.title || wTrans('are_you_sure'));
      state.description = unref(options.description || '');
      state.confirmText = unref(options.confirmText || wTrans('confirm'));
      state.cancelText = unref(options.cancelText || wTrans('cancel'));
      state.variant = variant;
      state.btnVariant = btnVariantMap[variant] || 'secondary';
      state.cancelColor = options.cancelColor || 'gray';
      state.loading = false;
      state.resolve = resolve;
      state.reject = reject;
      state.loadingFn = options.loadingFn || (() => {});
    });
  };
}

export function useDangerConfirmationModal() {
  const confirm = useConfirmationModal();
  return (options = {}) => confirm({ ...options, variant: 'danger' });
}

export function useConfirmationState() {
  return state;
}

export function resetConfirmationState() {
  // Manually reset each property to avoid reactivity issues
  state.visible = false;
  state.title = '';
  state.description = '';
  state.confirmText = 'Confirm';
  state.cancelText = 'Cancel';
  state.variant = 'primary';
  state.btnVariant = 'secondary';
  state.cancelColor = 'gray';
  state.loading = false;
  state.resolve = null;
  state.reject = null;
  state.loadingFn = null;
}